import { useMutation, useQuery } from '@tanstack/react-query';
import { LibrariesAPI, TLibraryData } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const librariesAPI = new LibrariesAPI(axios);

// GET libraries
export const useLibrariesQuery = (projectId?: string) => {
    return useQuery({
        queryKey: ['libraries', projectId],
        queryFn: async () => {
            if (!projectId) {
                throw new Error('Project ID is required');
            }

            return librariesAPI.getLibraries(projectId);
        },
        enabled: !!projectId
    });
};

// GET library
export const useLibraryQuery = (projectId?: string, libraryId?: string) => {
    return useQuery({
        queryKey: ['library', projectId, libraryId],
        queryFn: async () => {
            if (!projectId) {
                throw new Error('Project ID is required');
            }

            if (!libraryId) {
                throw new Error('Library ID is required');
            }

            return librariesAPI.getLibrary(projectId, libraryId);
        },
        enabled: !!projectId && !!libraryId
    });
};

// CREATE library
export const useCreateLibraryMutation = () => {
    return useMutation({
        mutationFn: async ({
            projectId,
            data
        }: {
            projectId: string;
            data: TLibraryData;
        }) => {
            if (!projectId) {
                throw new Error('Project ID is required');
            }

            return librariesAPI.createLibrary(projectId, data);
        }
    });
};

// UPDATE library
export const useUpdateLibraryMutation = () => {
    return useMutation({
        mutationFn: async ({
            projectId,
            libraryId,
            data
        }: {
            projectId: string;
            libraryId: string;
            data: TLibraryData;
        }) => {
            if (!projectId) {
                throw new Error('Project ID is required');
            }

            if (!libraryId) {
                throw new Error('Library ID is required');
            }
            return librariesAPI.updateLibrary(projectId, libraryId, data);
        }
    });
};

// DELETE library
export const useDeleteLibraryMutation = () => {
    return useMutation({
        mutationFn: async ({
            projectId,
            libraryId
        }: {
            projectId: string;
            libraryId: string;
        }) => {
            if (!projectId) {
                throw new Error('Project ID is required');
            }

            return librariesAPI.deleteLibrary(projectId, libraryId);
        }
    });
};
